import { Component, OnInit } from '@angular/core';
import { User } from 'app/models/user';
import { UserService } from 'app/services/user.service';
import { SettingsService } from 'app/services/settings.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'ng-uikit-pro-standard';
import { MdbCheckboxChange } from 'ng-uikit-pro-standard';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  selectedUsers: User[] = [];
  users: User[];
  nonAdminUsers: User[];
  administrators: User[] = [];
  tableLoadingIndicator: boolean = false;
  tableLimitSelect: Array<any>;
  selectedTableLimit: number = 5;

  isMFARequired: boolean = false;

  durations: any[] = [];
  selectedDuration: number = 10;
  characterNumbers: number = 6;
  defaultExpirDay: number = 3;
  defaultExpirHour: number = 3;
  maxExpirDay: number = 3;
  maxExpirHour: number = 3;

  filesRetentionFormGroup: FormGroup = null;
  isSavingFilesRetention: boolean = false;

  constructor(public userService: UserService, public settingsService: SettingsService,
              private ecoDocsTitleService: EcoDocsTitleService, private toastService: ToastService,
              private formBuilder: FormBuilder, private validationHandler: ValidationHandler) {
    this.filesRetentionFormGroup = this.formBuilder.group({
      versions_retention_days: [90, [Validators.required]],
      deleted_retention_days: [30, [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle('Settings', false);
    this.tableLimitSelect = [5, 10, 20, 30, 50, 100];
    this.userService.getAll().subscribe(u => {
      this.users = u;
      this.refreshNonAdminUsers();
    });
    this.refreshAdmins();

    this.settingsService.getIsMFARequired().subscribe((s) => {
      this.isMFARequired = s;
    });

    this.settingsService.getFilesRetention().subscribe((r) => {
      this.filesRetentionFormGroup.setValue(r);
    });
    
    this.durations = [
      {
        value: 1,
        duration: '1 Minute'
      },
      {
        value: 2,
        duration: '2 Minute'
      },
      {
        value: 3,
        duration: '3 Minute'
      },
      {
        value: 5,
        duration: '5 Minute'
      },
      {
        value: 10,
        duration: '10 Minute'
      },
      {
        value: 15,
        duration: '15 Minute'
      },
      {
        value: 20,
        duration: '20 Minute'
      },
      {
        value: 25,
        duration: '25 Minute'
      },
      {
        value: 30,
        duration: '30 Minute'
      },
      {
        value: 45,
        duration: '45 Minute'
      },
      {
        value: 60,
        duration: '1 Hour'
      },
      {
        value: 120,
        duration: '2 Hour'
      },
      {
        value: 180,
        duration: '3 Hour'
      },
      {
        value: 240,
        duration: '4 Hour'
      },
      {
        value: 300,
        duration: '5 Hour'
      },
      {
        value: 0,
        duration: 'Never'
      }
    ]
  }

  innerWidth() {
    return window.innerWidth;
  }

  refreshAdmins() {
    this.tableLoadingIndicator = true;
    this.userService.getAdmins().pipe(finalize(() => this.tableLoadingIndicator = false)).subscribe(a => {
      this.administrators = a;
      this.refreshNonAdminUsers();
    });
  }

  refreshNonAdminUsers() {
    this.nonAdminUsers = (this.users || []).filter((u) => (this.administrators || []).findIndex((a) => a.id == u.id) == -1);
  }

  removeAdmin(user: User) {
    this.tableLoadingIndicator = true;
    this.userService.deleteAdmin(user).pipe(finalize(() => this.refreshAdmins())).subscribe(() => {}, () => this.toastService.error('Error removing administrator!'));
  }

  addAdmins() {
    this.tableLoadingIndicator = true;
    this.userService.putAdmin(this.selectedUsers).pipe(finalize(() => this.refreshAdmins())).subscribe(() => this.selectedUsers = [], () => this.toastService.error('Error adding administrators!'));
  }

  onMFARequiredCheckChange(e: MdbCheckboxChange) {
    this.settingsService.postIsMFARequired(e.checked).subscribe(() => {
      this.toastService.success('MFA Settings Saved.');
    }, () => {
      this.toastService.error('Error saving MFA settings!');
    });
  }

  onSaveFilesRetention() {
    this.validationHandler.onSubmitCheck(this.filesRetentionFormGroup);
    if (!this.filesRetentionFormGroup.valid) {
      return;
    }

    this.isSavingFilesRetention = true;
    this.settingsService.postFilesRetention(this.filesRetentionFormGroup.value).pipe(finalize(() => {
      this.isSavingFilesRetention = false;
    })).subscribe(() => {
      this.toastService.success('Files Retention Settings Saved.');
    }, () => {
      this.toastService.error('Error saving files retention!');
    });
  }
}
